export default {
  titulo: { label: "Perfiles Asignados" }
  , id: { th: "Id" }
  , perfil: { th: "Perfil" }
  , errors: {
    BD2003: { text: "Ocurrió un error al asignar perfiles al usuario" }
    , WS2003: { text: "Ocurrió un error al asignar perfiles al usuario" }
    , JS2003: { text: "Ocurrió un error al asignar perfiles al usuario" }
    , CR2003: { text: "Ocurrió un error al asignar perfiles al usuario" }
    , PK2003: { text: "Ya existe un registro con el mismo usuario" }
    , UK_GroupMembers: { text: "Sólo es posible asignar un perfil por usuario" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/seguridad/usuarioPerfiles.js